import Grid from "components/primitives/Grid";
import IconButton from "components/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import * as Components from "./ChartLegend.components";
import ThemeProvider2024 from "components/MuiThemeProvider/ThemeProvider2024";
import { useTranslation } from "react-i18next";

interface ChartLegendItem {
  color: string;
  id: string;
  label: React.ReactNode;
  /** Plain-text hover title; defaults to the label when it is a string. */
  title?: string;
  remove?(): void;
}
interface ChartLegendProps {
  items: ChartLegendItem[];
  disableBorders?: boolean;
}

function ChartLegend(props: ChartLegendProps) {
  const { t } = useTranslation();
  return (
    <>
      <Components.GridChartLegendContainer container spacing="8px" width="100%" columns={12}>
        {props.items.map((item: ChartLegendItem, itemIndex) => {
          const title = item.title ?? (typeof item.label === "string" ? item.label : undefined);

          return (
            <Grid key={item.id + itemIndex} size={{ xs: 6, lg: 4, xl: 3 }} minWidth={240}>
              <Components.GridChartLegendItem
                container
                alignItems="center"
                wrap="nowrap"
                title={title}
                spacing={0}
                padding={0}
                disableBorders={props.disableBorders}
                width="100%"
              >
                {item.color ? (
                  <Grid>
                    <Components.ChartLegendColor style={{ background: item.color }} />
                  </Grid>
                ) : (
                  <Grid mr={2} />
                )}
                <Grid size="grow" title={title} minWidth={0}>
                  <Typography noWrap>{item.label}</Typography>
                </Grid>
                {item.remove && (
                  <Components.GridChartLegendRemoveX>
                    <ThemeProvider2024>
                      <IconButton
                        size="small"
                        onClick={item.remove}
                        title={t("global.delete_button_text")}
                        aria-label={t("global.delete_button_text")}
                      >
                        <CloseIcon fontSize="small" />
                      </IconButton>
                    </ThemeProvider2024>
                  </Components.GridChartLegendRemoveX>
                )}
              </Components.GridChartLegendItem>
            </Grid>
          );
        })}
      </Components.GridChartLegendContainer>
    </>
  );
}

export default ChartLegend;
